import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { vrStatuses } from './model/vacation-request.model';
import Swal from 'sweetalert2';
import { SharedService } from '../../shared.service';
import { APP_CONFIG, AppConfig } from '../../app-config.token';


let BASE_URL = '', MASTER_API_URL = '';

@Injectable({
  providedIn: 'root'
})
export class VacationRequestService {

  private vrStatues: any[] = [];

  setVRStatuses(res: any[]) {
    this.vrStatues = res;
  }
  getVRStatus(status: string ): string {
    return this.vrStatues.find((s:any) => (s.text == status || s.value == status))?.value;
  }


  constructor(
    private readonly http: HttpClient, 
    private sharedService: SharedService,
    @Inject(APP_CONFIG) private config: AppConfig

  ) { 
    MASTER_API_URL = config.masterApiURL || '';
    BASE_URL = config.saleApiUrl || '';
  }



  public static apiCallsInProgress = 0;
  public static invalidDataCount = 0;
  private readonly pendingApiCalls: any[] = [];
  invalidDataSections: any[] = [];

  private readonly allCallsCompleted = new BehaviorSubject<boolean>(false);


  allCallsCompleted$ = this.allCallsCompleted.asObservable();

  getVacationReqById(vrfId: string) {
    return this.http.get(`${MASTER_API_URL}odata/vacationReqById?vrfId=${vrfId}`);
  }
  getImpact(p:{userId: string, startDate: string|Date, endDate: string|Date}) {
    return this.http.get(`${MASTER_API_URL}odata/impact?count=true&VacationStartDate=${p.startDate}&VacationEndDate=${p.endDate}&userId=${p.userId}`);
  }
  getEndDate(p:{userId: string, startDate: string|Date, duration: number}) {
    return this.http.get(`${MASTER_API_URL}odata/EndDate?userId=${p.userId}&StartDate=${p.startDate}&Duration=${p.duration}`);
  }
  saveVacationRequest(payload: any) {
    return this.http.post(`${MASTER_API_URL}odata/SaveVacationRequest?userId=${payload?.userId}`, payload);
  }
  updateStatusTo(p: any) {
    let {userId, comment, vrfId, status} = p;
    return this.http.post(`${MASTER_API_URL}odata/VacationRequestStatus`, {userId, comment, vrfId, status});
  }
  deleteRequest(vrfId: string) {
    return this.http.post(`${MASTER_API_URL}odata/DeleteVacationRequest?vrfId=${vrfId}`, {});
  }

  getVacationRequestsStatus() {
    return this.http.get(`${MASTER_API_URL}Common/GetStatusDDL?module=vacationReq`);
  }
  setInvalidData(invalid: boolean, source: string) {
    if(invalid) {
      const uniqueData = Array.from(new Set(this.invalidDataSections));
    !uniqueData.includes(source) && uniqueData.push(source);

      this.invalidDataSections = uniqueData;
      VacationRequestService.invalidDataCount = this.invalidDataSections.length;
      console.log("this.invalidDataSections =============", this.invalidDataSections)
    } else {
      VacationRequestService.invalidDataCount--;

      const i = this.invalidDataSections.findIndex((p: string)=> p == source);
      i > -1 && this.invalidDataSections.splice(i, 1);
      VacationRequestService.invalidDataCount = this.invalidDataSections.length;
      console.log("this.invalidDataSections =============", this.invalidDataSections)
    }
  }

  apiCallStarted(startedFrom: string) {
    VacationRequestService.apiCallsInProgress++;
    this.pendingApiCalls.push(startedFrom);
    this.allCallsCompleted.next(false);
    console.log("pendingApiCalls ==> :",this.pendingApiCalls);
  }


  apiCallCompleted(endedFrom: string) {
    VacationRequestService.apiCallsInProgress--;
    const i = this.pendingApiCalls.findIndex((p)=> p == endedFrom);
    i > -1 && this.pendingApiCalls.splice(i, 1);
    // console.log("pendingApiCalls ==> :",this.pendingApiCalls);
    if (VacationRequestService.apiCallsInProgress === 0) {
      this.allCallsCompleted.next(true);
    }
  }

  showCommentOnRejectionModal(data): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `Please add a comment before rejecting the vacation request: ${data?.vrfId}?`,
        input: "text",
        inputPlaceholder: "Add comment here!",
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: `Cancel`,
        confirmButtonColor: '#d9534f',
        focusConfirm: false,
        confirmButtonText: `Reject`,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        }
      }).then(res => {
        if (res?.isConfirmed) {
          data.comment = res?.value;
          data['status'] = vrStatuses.rejected;
          this.updateStatusTo(data).subscribe({
            next: (res: any) => {
              this.sharedService.showNotification("success", "Message: "+res);
              resolve(res);
            },
            error: (err: any) => {
              this.sharedService.showNotification("error", err?.message);
              reject(err);
            }
          });
        }
      });
    })
    }
}
